import { connect } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";
import { Helmet } from "react-helmet-async";
import CustomDatatable from "../../components/CustomDatatable/CustomDatatable";
import { useEffect, useState } from "react";
import "../../assets/scss/_commomAdminPages.scss";
import FilterAdmin from "../../components/FilterAdmin/FilterAdmin";
import renderFormatedDate from "../../components/RenderCellsDatatable/renderFormatterDate";
import { useIsFirstRender } from "../../customHooks/useIsFirstRender";
import {
  changePageSizeLogo,
  cleanMessageLogo,
  getListaLogo,
  getLogoHistoryList,
  loadEmptyLogo,
} from "../../store/logo/actions";
import renderHeader from "../../components/RenderCellsDatatable/renderHeader";
import renderBoolean from "../../components/RenderCellsDatatable/renderBoolean";
import HistoryModal from "../../components/HistoryModal/HistoryModal";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useContextActions } from "../../customHooks/useContextActions";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import { PAGE_SIZE_OPTIONS } from "../../constants/pagination";

const LogoList = ({
  getLogoRequest,
  loadingLogo,
  listaLogo,
  loadingLogoHistory,
  listaLogoHistory,
  loadEmptyLogo,
  changePageSizeLogo,
  pageSizeLogo,
  getLogoHistoryList,
  messageLogo,
  cleanMessageLogo,
  errorLoadingLogoHistory,
}) => {
  const isFistRender = useIsFirstRender();
  const navigate = useNavigate();
  
  const [objFilter, setObjFilter] = useState({
    createDateStart: null,
    updateDateStart: null,
    createDateEnd: null,
    updateDateEnd: null,
    createUser: null,
    updateUser: null,
    status: true,
  });

  const [paginationModel, setPaginationModel] = useState({
    pageSize: pageSizeLogo,
    page: 0,
  });

  const [currentPageHistory, setCurrentPageHistory] = useState(1);
  const [idCurrentLogoHistory, setIdCurrentLogoHistory] = useState(null);
  const pageSizeHistory = 10;
  const totalPagesHistory = Math.ceil(
    (listaLogoHistory?.totalRecords || 0) / pageSizeHistory
  );
  const handlePageChangeHistory = (page) => {
    if (!idCurrentLogoHistory) return;
    if (page < 1 || page > totalPagesHistory) return;
    setCurrentPageHistory(page);

    getLogoHistoryList({ 
      logoId: idCurrentLogoHistory, 
      page 
    });
  };

  const alertModal = withReactContent(Swal);

  const fetchLogoHistory = (logoId) => {
    getLogoHistoryList({ logoId, page: 1 });
  };

  const handleDetailLogoHistory = (item) => {
    window.open(`/logo?idHistory=${item.idHistory}`, "_blank");
  };

  const columns = [
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "active",
      headerName: "Active Status",
      flex: 1,
      type: "boolean",
      sortable: false,
      renderHeader: renderHeader,
      renderCell: renderBoolean,
    },
    {
      field: "createDate",
      headerName: "Creation Date",
      flex: 1,
      renderCell: renderFormatedDate,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "updateDate",
      headerName: "Update Date",
      flex: 1,
      renderCell: renderFormatedDate,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "id",
      headerName: "History",
      flex: 1,
      renderCell: (params) => (
        <HistoryModal
          trigger={
            <Button color="" style={{ width: 50, height: 50 }}>
              <i className="fas fa-history"></i>
            </Button>
          }
          fetchHistory={() => {
            fetchLogoHistory(params.value)
            setCurrentPageHistory(1);
            setIdCurrentLogoHistory(params.value);
          }}
          loading={loadingLogoHistory}
          data={listaLogoHistory?.records}
          onDetail={handleDetailLogoHistory}
          errorLoadingHistory={errorLoadingLogoHistory}

          handlePageChange={handlePageChangeHistory}
          totalPages={totalPagesHistory}
          currentPage={currentPageHistory}

          columns={[
            {
              key: "updateDate",
              render: (item) => moment(item.updateDate === null ? item.createDate : item.updateDate).format("DD MMM/YY hh:mm A"),
            },
            { key: "title" },
            { key: "updateUser",
              render: (item) => item.updateUser === null ? item.createUser : item.updateUser
             },
          ]}
        />
      ),
      sortable: false,
      renderHeader: renderHeader,
    },
  ];

  const handlePageChange = (model) => {
    const { page, pageSize } = model;
    setPaginationModel({
      pageSize: pageSize,
      page: page,
    });

    changePageSizeLogo(pageSize);
    getLogoRequest({
      pageNumber: page + 1,
      pageSize: pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      createUser: objFilter.createUser,
      updateUser: objFilter.updateUser,
      status: objFilter.status,
      title: objFilter.search,
    });
  };

  const handleSortChange = (model) => {
    console.log(model);
    setTimeout(() => {
      //
    }, 300);
  };

  const handleRowClick = (params, event) => {
    navigate(`/logo?id=${params.id}`);
  };

  const actions = useContextActions({
    context: "logo",
    screen: "list",
  })

  useEffect(() => {
    if (isFistRender) loadEmptyLogo();

    setPaginationModel((prev) => ({
      ...prev,
      page: 0,
    }));

    getLogoRequest({
      pageNumber: 1,
      pageSize: paginationModel.pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      createUser: objFilter.createUser,
      updateUser: objFilter.updateUser,
      status: objFilter.status,
      title: objFilter.search,
    });

    // eslint-disable-next-line
  }, [objFilter]);

  useEffect(() => {
    if (messageLogo) {
      alertModal
        .fire({
          title: `${
            messageLogo !== null
              ? messageLogo
              : "Something wrong, try again later."
          }`,
          icon: "error",
          showConfirmButton: false,
          timer: undefined,
          showCloseButton: true,
          timerProgressBar: false,
        })
        .then(() => {
          cleanMessageLogo();
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageLogo]);

  useEffect(() => {
    return () => {
      cleanMessageLogo();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-content">
      <Helmet>
        <title>Logo</title>
      </Helmet>
      <div></div>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <div>
                  <Row>
                    <div className="d-flex justify-content-between my-2">
                      <h2>LOGO</h2>
                      <ActionButtons 
                        actions={actions}
                        context="logo"
                        handlers={{
                          create: () => navigate("/logo")
                        }}
                      />
                    </div>
                  </Row>
                  <FilterAdmin
                    setObjFilter={setObjFilter}
                    placeholderSearch={"Search by logo title"}
                    isFistRender={isFistRender}
                  />
                  <Row className="my-2">
                    {loadingLogo ? (
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ height: "400px", width: "100%" }}
                      >
                        <Spinner
                          color="primary"
                          style={{ height: "5rem", width: "5rem" }}
                        />
                      </div>
                    ) : (
                      <>
                        <CustomDatatable
                          columns={columns}
                          rows={listaLogo.records}
                          rowCount={listaLogo.totalRecords}
                          pagination
                          paginationMode="server"
                          paginationModel={paginationModel}
                          onPaginationModelChange={handlePageChange}
                          onSortModelChange={handleSortChange}
                          onRowClick={handleRowClick}
                          pageSizeOptions={PAGE_SIZE_OPTIONS}
                          checkboxSelection={false}
                          disableColumnFilter
                          disableColumnMenu
                        />
                      </>
                    )}
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = ({
  LogoReducer: { loadingLogo, loadingLogoHistory, listaLogo, pageSizeLogo, listaLogoHistory, messageLogo, errorLoadingLogoHistory, },
}) => ({
  loadingLogo,
  loadingLogoHistory,
  listaLogo,
  pageSizeLogo,
  listaLogoHistory,
  messageLogo,
  errorLoadingLogoHistory,
});

const mapDispatchToProps = {
  getLogoRequest: getListaLogo.request,
  getLogoHistoryList: getLogoHistoryList.request,
  loadEmptyLogo,
  changePageSizeLogo,
  cleanMessageLogo
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoList);
